import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import Default from '~/templates/Default';

import Seo from '~/layout/SEO';

import CtaBar from '~/components/blocks/acf/CtaBar';
import Hero from '~/components/hero';
import SiteSearch from '~/components/SiteSearch';

const PageNotFound = () => {
    const {
        wp: {
            siteSettings: {
                siteSettings: { leftTitle, rightTitle, footerCtas }
            }
        }
    } = useStaticQuery(graphql`
        query {
            wp {
                siteSettings {
                    siteSettings {
                        leftTitle
                        rightTitle
                        footerCtas {
                            link {
                                url
                                title
                            }
                        }
                    }
                }
            }
        }
    `);

    return (
        <Default>
            <Hero
                component="basic"
                backgroundColor="darkBlue"
                padding="medium"
                graphicImage={['blueHeroLeft', 'blueHeroRight']}
                title="Oops!"
                copy="We're sorry! The page you're looking for cannot be found. Please search again."
                contentPlacement="center"
                globalBlockOptions={{ marginBottom: 'none' }}
            >
                <SiteSearch useSearchDialog={false} />
            </Hero>
            <CtaBar
                variant="findYourCarWash"
                backgroundColor="blue"
                displayMobileSearch
                ctas={footerCtas}
                globalBlockOptions={{
                    marginBottom: 'none'
                }}
                {...{ leftTitle, rightTitle }}
            />
        </Default>
    );
};

export default PageNotFound;

export const Head = ({ location }) => (
    <Seo {...{ location }} title="404: Not found" />
);
